import { useLocation, useNavigate } from "react-router-dom";
import StoneOrb from "@/components/yuo/StoneOrb";
import { MFONT } from "./MobileHeader";

export const DOCK_ROOMS = [
  { to: "/mirror",    label: "Mirror",    room: "mirror",    testId: "tab-mirror" },
  { to: "/diary",     label: "Diary",     room: "diary",     testId: "tab-diary" },
  { to: "/library",   label: "Library",   room: "library",   testId: "tab-library" },
  { to: "/content",   label: "Creator",   room: "content",   testId: "tab-content" },
  { to: "/symbiosis", label: "Symbiosis", room: "symbiosis", testId: "tab-symbiosis" },
];

// Room dock — 5 stones. Active 26px + glow, others 18px.
export default function MobileDock() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav data-testid="bottom-nav" style={{
      position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 50, fontFamily: MFONT,
      padding: "10px 6px calc(26px + env(safe-area-inset-bottom, 0px))",
      background: "var(--m-dock-bg)", display: "flex", justifyContent: "space-around", alignItems: "flex-end",
    }}>
      {DOCK_ROOMS.map((t) => {
        const active = pathname === t.to || pathname.startsWith(t.to + "/");
        return (
          <button key={t.to} type="button" data-testid={t.testId} aria-label={t.label} onClick={() => navigate(t.to)} style={{
            background: "transparent", border: "none", boxShadow: "none", padding: 0, cursor: "pointer",
            display: "flex", flexDirection: "column", alignItems: "center", gap: 6, minWidth: 56, height: 50, justifyContent: "flex-end",
          }}>
            <StoneOrb color={t.room} size={active ? 26 : 18} glow={active} />
            <span style={{ fontSize: 7.5, letterSpacing: "0.2em", textTransform: "uppercase", color: active ? "var(--yuo-ink)" : "var(--m-dock-idle)" }}>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
